import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';

import { showStats } from 'actions/gameActions';
import { GO_BACK, HELP, SPEAK, NEXT, PRINT } from 'consts/buttons';
import { toggleAudio, stopAudio } from 'actions/audioActions';
import { activitiesURL, activitiesKey } from 'config';
import { validateProblem } from './readingDeluxeHelpers';
import {
  getTimerPage,
  inheritReadingTimerMetadata,
  isUsableTimerPage,
  shouldStartTimerOnCurrentPage,
  shouldShowTimer,
  shouldShowTimerStart,
  shouldShowTimerStop,
  shouldHideNextButton,
  validateProblemForTimerMode,
} from './readingDeluxeTimerLayer';
import {
  AdaptiveContainer,
  ActivityButtons,
  EbookComponent,
  EbookTimer,
  Instructions
} from 'components/flink-play';
import API from 'api';
import isMobileAppRuntime from 'utils/isMobileAppRuntime';
import { isReadingLocaleDebugEnabled, logReadingLocale } from 'utils/readingLocaleDiagnostics';
import './ReadingDeluxe.mobile.scss';

class ReadingDeluxe extends Component {
  state = {};

  timerInterval = null;

  componentDidMount() {
    document.addEventListener('startGame', this.init);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.currentPageIdx !== this.state.currentPageIdx) {
      this.onPageChange();
    }
  }

  componentWillUnmount() {
    this.clearTimerInterval();
    document.removeEventListener('startGame', this.init);
  }

  /*init = () => {
    const {
      activity: {
        activity: { _id },
      }
    } = this.props;

    const thisVersion = !this.props.isPlayVersion ? this.props.activity.activity.currentLanguageVersion 
    : {version: 'immersion', locale: this.props.solutionLocale.code};
    const versionType = thisVersion && thisVersion.version && thisVersion.locale ? `${thisVersion.version}_${thisVersion.locale}` : "";    
    const gameData = versionType 
    ? this.props.activity.data.languageVersionData?.[versionType]
    : this.props.activity.data.gameData;
    const { problems } = gameData;

    const validPages = _.filter(problems, validateProblem);
    const assetsFolder = versionType ? `${activitiesURL}/${_id}/languageVersionData/${versionType}/`
    : `${activitiesURL}/${_id}/gamedata/`;

    this.setState({
      timerStarted: false,
      spentTime: 0,
      assetsFolder,
      currentPageIdx: 0,
      pages: validPages,
      versionType,
      gameData
    });
  };*/

  /*init = () => {
    const {
      activity: {
        activity: { _id },
        data,
      },
    } = this.props;
  
    console.log('Activity Data:', data);
  
    const thisVersion = !this.props.isPlayVersion
      ? this.props.activity.activity.currentLanguageVersion
      : { version: 'immersion', locale: this.props.solutionLocale.code };
  
    console.log('This Version:', thisVersion);
  
    const versionType =
      thisVersion && thisVersion.version && thisVersion.locale
        ? `${thisVersion.version}_${thisVersion.locale}`
        : "";
  
    console.log('Version Type:', versionType);
  
    let gameData = null;
    let assetsFolder = null;
  
    if (versionType && data.languageVersionData?.[versionType]) {
      gameData = data.languageVersionData[versionType];
      assetsFolder = `${activitiesURL}/${_id}/languageVersionData/${versionType}/`;
      console.log('Using immersion data:', gameData);
    } else if (data.gameData) {
      gameData = data.gameData;
      assetsFolder = `${activitiesURL}/${_id}/gamedata/`;
      console.log('Fallback to gamedata:', gameData);
    }
  
    if (!gameData || !gameData.problems) {
      console.error('Game Data or Problems missing:', gameData);
      return;
    }
  
    const validPages = _.filter(gameData.problems, validateProblem);
  
    this.setState({
      timerStarted: false,
      spentTime: 0,
      assetsFolder,
      currentPageIdx: 0,
      pages: validPages,
      versionType,
      gameData,
    });
  };*/
  
  init = () => {
    // startGame may be emitted more than once while the activity is mounting.
    // Always reset the previous timer before initializing the e-book state.
    this.clearTimerInterval();

    const {
        activity: {
            activity: { _id  },
            data,
        },
         
    } = this.props;

    console.log('Activity Data:', data);

    /*const locale = monolingual ? '' 
        : (currentLanguageVersion?.locale 
            ? currentLanguageVersion.locale
            : solutionLocale?.code ? solutionLocale.code : '');*/
    const locale = this.props.activity.activity?.monolingual ? ''
    : (window.location.href.indexOf('edit-activities') !== -1 &&
        this.props.activity.activity?.currentLanguageVersion?.locale 
      ? this.props.activity.activity.currentLanguageVersion.locale
      : this.props?.solutionLocale?.code ? this.props.solutionLocale.code : '');

    const versionType = (!locale || locale === 'en') ? "" : `immersion_${locale}`;

    console.log('Version Type:', versionType);

    let gameData = null;
    let assetsFolder = null;

    if (versionType && data.languageVersionData?.[versionType]) {
        gameData = data.languageVersionData[versionType];
        assetsFolder = `${activitiesURL}/${_id}/languageVersionData/${versionType}/`;
        console.log('Using immersion data:', gameData);
    } else if (data.gameData) {
        gameData = data.gameData;
        assetsFolder = `${activitiesURL}/${_id}/gamedata/`;
        console.log('Fallback to gamedata:', gameData);
    }

    if (!gameData || !gameData.problems) {
        console.error('Game Data or Problems missing:', gameData);
        return;
    }

    const options = data?.options || {};
    const timerModeData = data?.gameData || {};
    const basePages = Array.isArray(timerModeData.problems) ? timerModeData.problems : [];
    const selectedPages = Array.isArray(gameData.problems) ? gameData.problems : [];
    const pagesWithTimerMetadata = selectedPages.map((problem, pageIndex) => {
      if (!versionType || !problem) return problem;
      const basePage = basePages.find(page => page?.id && page.id === problem.id) ||
        basePages[pageIndex];
      return inheritReadingTimerMetadata(problem, basePage);
    });
    if (isReadingLocaleDebugEnabled()) {
      logReadingLocale('activity-data', {
        activityId: _id,
        activityName: this.props.activity?.activity?.activityName || null,
        template: this.props.activity?.template?.alias || null,
        preview: !!this.props.preview,
        isPlayVersion: !!this.props.isPlayVersion,
        monolingual: !!this.props.activity?.activity?.monolingual,
        currentLanguageVersion: this.props.activity?.activity?.currentLanguageVersion || null,
        contentLocale: this.props.solutionLocale?.code || null,
        presentationLocale: this.props.presentationLocale?.code || null,
        selectedVersionType: versionType || '(base gameData)',
        source: gameData === data.gameData ? 'gameData' : `languageVersionData.${versionType}`,
        languageVersionKeys: Object.keys(data.languageVersionData || {}),
        basePagesCount: basePages.length,
        selectedPagesCount: selectedPages.length,
        selectedPageInstructions: selectedPages.map((page, index) => ({
          index,
          id: page?.id || null,
          instructionString: page?.instructionString ?? null,
          instructionText: page?.instructionText ?? null,
          instructionAudio: page?.instructionAudio ?? null,
          multiLocaleInstructions: page?.multiLocaleInstructions || null,
        })),
        basePageInstructions: basePages.map((page, index) => ({
          index,
          id: page?.id || null,
          instructionString: page?.instructionString ?? null,
          instructionText: page?.instructionText ?? null,
          multiLocaleInstructions: page?.multiLocaleInstructions || null,
        })),
      });
    }

    const validPages = pagesWithTimerMetadata.filter((problem, pageIndex) =>
      problem && validateProblemForTimerMode({
        options,
        gameData: timerModeData,
        problem,
        pageIndex,
        validateProblem,
        allowIncompleteTimer: true
      })
    );

    const incompleteTimerPages = pagesWithTimerMetadata.filter(
      page => page?.hasTimer && !isUsableTimerPage(page)
    );
    if (incompleteTimerPages.length) {
      console.warn('[ReadingDeluxe][incomplete-timer-data]', {
        activityId: _id,
        versionType,
        pages: incompleteTimerPages.map(page => page.id),
        // Published data.json must contain benchmark and totalWords; this
        // runtime cannot invent missing values from Make App Preview.
      });
    }

    this.setState({
        timerStarted: false,
        spentTime: 0,
        assetsFolder,
        currentPageIdx: 0,
        pages: validPages,
        versionType,
        gameData,
    }, this.startTimerIfCurrentPageHasTimer);
};



  showPrevPage = () => {
    const { currentPageIdx } = this.state;
    const isFirstPage = currentPageIdx === 0;

    if (!isFirstPage) {
      this.setState({ currentPageIdx: currentPageIdx - 1 });
    }
  };

  showNextPage = () => {
    const { currentPageIdx, pages } = this.state;
    const isLastPage = pages.length === currentPageIdx + 1;

    if (!isLastPage) {
      this.setState({ currentPageIdx: currentPageIdx + 1 });
    }
  };

  onPageChange = () => {
    stopAudio();
    this.startTimerIfCurrentPageHasTimer();
    // this.playPageAudio();
  };

  getCurrentPage = () => {
    const { pages, currentPageIdx } = this.state;
    if (!Array.isArray(pages)) return null;

    const page = pages[currentPageIdx];
    if (!page) return null;

    const relatedPage = page.textFrom ? _.find(pages, { id: page.textFrom }) : null;
    const selectedText = relatedPage ? relatedPage.text : page.text;
    const text = Array.isArray(selectedText) ? selectedText
      .filter(block => block && typeof block === 'object' && !Array.isArray(block))
      .map(block => ({
      ...block,
      // Older published reading pages can lack text block geometry. Without
      // defaults EbookComponent throws on the second page (t.dim destructure).
      dim: {
        width: '100%',
        height: '100%',
        left: '0',
        top: '0',
        ...(block.dim || {})
      }
    })) : [];

    return { ...page, text };
  };

  getPresentationInstructionPage = (page) => {
    if (!page || window.location.href.indexOf('edit-activities') !== -1) {
      return page;
    }

    // The selected Reading version is the authority for instruction text.
    // The global Login/Play locale can still be EN while immersion_es is active.
    // Never replace the selected version's Instructions with immersion_en.
    const contentLocaleCode = this.props.solutionLocale?.code || 'en';
    const selectedVersion = this.state.versionType || '';
    const localeCode = selectedVersion.includes('_')
      ? selectedVersion.slice(selectedVersion.indexOf('_') + 1)
      : contentLocaleCode;
    if (isReadingLocaleDebugEnabled()) {
      const candidateVersion = `immersion_${localeCode || ''}`;
      const candidatePages = this.props.activity?.data?.languageVersionData?.[candidateVersion]?.problems;
      const translatedCandidate = Array.isArray(candidatePages)
        ? (candidatePages.find(candidate => candidate?.id && candidate.id === page.id)
          || candidatePages[this.state.currentPageIdx])
        : null;
      logReadingLocale('instruction-page-selection', {
        activityId: this.props.activity?.activity?._id || null,
        pageIndex: this.state.currentPageIdx,
        pageId: page.id || null,
        contentLocale: contentLocaleCode,
        presentationLocale: localeCode || null,
        sourceInstruction: {
          instructionString: page.instructionString ?? null,
          instructionText: page.instructionText ?? null,
          instructionAudio: page.instructionAudio ?? null,
          multiLocaleInstructions: page.multiLocaleInstructions || null,
        },
        candidateVersion,
        candidateVersionExists: !!this.props.activity?.data?.languageVersionData?.[candidateVersion],
        candidatePageFound: !!translatedCandidate,
        candidateInstruction: translatedCandidate ? {
          instructionString: translatedCandidate.instructionString ?? null,
          instructionText: translatedCandidate.instructionText ?? null,
          instructionAudio: translatedCandidate.instructionAudio ?? null,
          multiLocaleInstructions: translatedCandidate.multiLocaleInstructions || null,
        } : null,
      });
    }
    if (!localeCode || localeCode === contentLocaleCode) return page;

    const localizedPages = this.props.activity?.data?.languageVersionData?.[
      `immersion_${localeCode}`
    ]?.problems;
    if (!Array.isArray(localizedPages)) return page;

    const translatedPage = localizedPages.find(
      candidate => candidate?.id && candidate.id === page.id
    ) || localizedPages[this.state.currentPageIdx];
    if (!translatedPage) return page;

    const instructionFields = [
      'instructionText', 'instructionString', 'instructionAudio',
      'multiLocaleInstructions'
    ];
    const localized = instructionFields.reduce((result, field) => {
      const value = translatedPage[field];
      if (value !== undefined && value !== null && value !== '') {
        result[field] = value;
      }
      return result;
    }, {});

    if (!Object.keys(localized).length) return page;

    // Do not let the English base page's numbered instruction override the
    // Spanish text authored in the alternate language version.
    const localizedInstructions = translatedPage.multiLocaleInstructions?.[localeCode];
    if (localizedInstructions?.instructionString) {
      localized.instructionString = localizedInstructions.instructionString;
    } else if (
      translatedPage.instructionString === undefined &&
      (localized.instructionText || localizedInstructions?.instructionText)
    ) {
      localized.instructionString = '';
    }

    return { ...page, ...localized };
  };

  normalizeAudioFilename = (value) => {
    if (typeof value !== 'string') return '';

    const filename = value.trim();
    if (!filename || filename === 'INHERITED' || /^0+$/.test(filename)) {
      return '';
    }

    return filename;
  };

  getCurrentPageAudio = () => {
    const currentPage = this.getCurrentPage();
    if (!currentPage) return null;

    const { pages, currentPageIdx, assetsFolder, versionType } = this.state;
    const selectedPages = Array.isArray(pages) ? pages : [];
    const relatedPage = currentPage.textFrom
      ? _.find(selectedPages, { id: currentPage.textFrom })
      : null;
    const selectedAudio =
      this.normalizeAudioFilename(currentPage.audio) ||
      this.normalizeAudioFilename(relatedPage?.audio);

    if (selectedAudio) {
      return {
        filename: selectedAudio,
        url: `${assetsFolder}${selectedAudio}`,
      };
    }

    if (!versionType) return null;

    const { activity, data } = this.props.activity;
    const basePages = Array.isArray(data?.gameData?.problems)
      ? data.gameData.problems
      : [];
    const basePage =
      (currentPage.id && _.find(basePages, { id: currentPage.id })) ||
      basePages[currentPageIdx] ||
      null;
    const relatedBasePageId = basePage?.textFrom || currentPage.textFrom;
    const relatedBasePage = relatedBasePageId
      ? _.find(basePages, { id: relatedBasePageId })
      : null;
    const baseAudio =
      this.normalizeAudioFilename(basePage?.audio) ||
      this.normalizeAudioFilename(relatedBasePage?.audio);

    if (!baseAudio || !activity?._id) return null;

    return {
      filename: baseAudio,
      url: `${activitiesURL}/${activity._id}/gamedata/${baseAudio}`,
    };
  };

  playPageAudio = () => {
    const pageAudio = this.getCurrentPageAudio();
    if (!pageAudio) return;

    toggleAudio(pageAudio.url);
  };

  startTimerIfCurrentPageHasTimer = () => {
    const { pages, currentPageIdx } = this.state;
    const options = this.props.activity?.data?.options || {};
    const timerModeData = this.props.activity?.data?.gameData || {};

    if (shouldStartTimerOnCurrentPage({
      options,
      gameData: timerModeData,
      pages,
      currentPageIdx
    })) {
      this.startTimer();
    }
  };

  clearTimerInterval = () => {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
      this.timerInterval = null;
    }
  };

  startTimer = () => {
    // Do not rely only on React state here. init() and componentDidUpdate() can
    // both request a timer start in the same update cycle, before timerStarted
    // has been committed. The interval reference is the synchronous lock.
    if (this.timerInterval) return;

    this.timerInterval = setInterval(this.increaseTimer, 1000);
    this.setState({ timerStarted: true });
  };

  stopTimer = () => {
    const { timerStarted } = this.state;
    if (!timerStarted && !this.timerInterval) return;

    this.clearTimerInterval();
    this.setState({ timerStarted: false }, this.showResults);
  };

  increaseTimer = () => {
    // Ignore a queued interval tick after Stop or unmount.
    if (!this.timerInterval) return;

    this.setState(state => ({
      spentTime: state.spentTime + 1
    }));
  };

  openPdf = async () => {
    const {
      activity: { activity, data },
    } = this.props;

    const { gameData, versionType } = this.state;
    const localizedPdf = gameData ? gameData.pdf : '';
    const fallbackPdf = data?.gameData?.pdf || '';
    const localizedKey = versionType && localizedPdf
      ? `${activitiesKey}/${activity._id}/languageVersionData/${versionType}/${localizedPdf}`
      : '';
    const fallbackKey = fallbackPdf
      ? `${activitiesKey}/${activity._id}/gamedata/${fallbackPdf}`
      : '';

    console.log('[ReadingDeluxe][openPdf][resolve]', {
      activityId: activity?._id,
      versionType,
      localizedPdf,
      fallbackPdf,
      localizedKey,
      fallbackKey,
    });

    if (localizedKey) {
      const localizedExists = await API.storage.checkIfFileExists(localizedKey, true);
      console.log('[ReadingDeluxe][openPdf][localizedCheck]', {
        localizedKey,
        localizedExists,
      });

      if (localizedExists) {
        return API.storage.openPdf(localizedKey, true);
      }
    }

    if (fallbackKey) {
      console.log('[ReadingDeluxe][openPdf][fallback]', { fallbackKey });
      return API.storage.openPdf(fallbackKey, true);
    }

    console.log('[ReadingDeluxe][openPdf][missingPdf]', {
      activityId: activity?._id,
      versionType,
    });
  };

  showResults = () => {
    const { showStats } = this.props;
    const { spentTime, pages, currentPageIdx } = this.state;
    const options = this.props.activity?.data?.options || {};
    const timerModeData = this.props.activity?.data?.gameData || {};
    const timerPage = getTimerPage({
      options,
      gameData: timerModeData,
      pages,
      currentPageIdx
    });

    if (!timerPage) return;

    const isLastPage = pages.length === currentPageIdx + 1;
    const { totalWords, benchmark } = timerPage;
    // The Stop action can be triggered before the first 1-second interval tick.
    const speed = Math.round((Number(totalWords) / Math.max(1, spentTime)) * 60);

    this.setState({ spentTime: 0 });

    showStats({
      data: { speed, benchmark },
      ebookBenchmark: {
        benchmark,
        totalWords,
        speed,
        spentTime
      },
      onlyCloseButton: !isLastPage
    });
  };

  render() {
    const {
      assetsFolder,
      currentPageIdx,
      pages,
      spentTime,
      timerStarted,
      gameData 
    } = this.state;
    const pdf = gameData ? gameData.pdf : '';

    const currentPage = this.getCurrentPage();
    const pageAudio = this.getCurrentPageAudio();
    const options = this.props.activity?.data?.options || {};
    const timerModeData = this.props.activity?.data?.gameData || {};
    const isLastPage = pages && pages.length === currentPageIdx + 1;
    const timerArgs = {
      options,
      gameData: timerModeData,
      pages,
      currentPageIdx
    };
    const displayTimer = shouldShowTimer(timerArgs);
    const mobileLayout = isMobileAppRuntime();

    const Layout = mobileLayout ? 'div' : React.Fragment;
    const mobileLayoutClass = displayTimer
      ? 'reading-deluxe-mobile-layout'
      : 'reading-deluxe-mobile-layout reading-deluxe-mobile-layout--no-timer';

    return (
      <Layout {...(mobileLayout ? { className: mobileLayoutClass } : {})}>
        <AdaptiveContainer
          className="reading-deluxe-instructions-slot"
          smallWidth={100}
          largeWidth={105 + 6}
          style={{
            position: 'absolute',
            left: '50%',
            top: '1%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: !mobileLayout && displayTimer ? 'space-between' : 'center',
            transform: 'translateX(-50%)'
          }}
        >
          {!mobileLayout && displayTimer && (
            <EbookTimer
              showStart={shouldShowTimerStart({
                ...timerArgs,
                timerStarted
              })}
              startHandler={this.startTimer}
              showStop={shouldShowTimerStop({
                ...timerArgs,
                timerStarted,
                isLastPage
              })}
              stopHandler={this.stopTimer}
              spentTime={spentTime}
            />
          )}

         { <Instructions
            readingLocaleDiagnostics
            problem={this.getPresentationInstructionPage(currentPage)}
            // Use the locale of the selected Reading version for BOTH Preview
            // and Play. This affects numbered Instructions, not page content
            // or the existing instruction-audio selection.
            solutionLocaleOverride={this.props.solutionLocale}
            instructionTextLocale={
              this.state.versionType?.includes('_')
                ? this.state.versionType.slice(this.state.versionType.indexOf('_') + 1)
                : this.props.solutionLocale?.code
            }
            wrapperStyle={{ position: 'static', transform: 'none' }}
          /> }
        </AdaptiveContainer>

        {mobileLayout && displayTimer && (
          <div className="ebook-mobile-timer reading-deluxe-mobile-timer">
            <EbookTimer
              showStart={shouldShowTimerStart({
                ...timerArgs,
                timerStarted
              })}
              startHandler={this.startTimer}
              showStop={shouldShowTimerStop({
                ...timerArgs,
                timerStarted,
                isLastPage
              })}
              stopHandler={this.stopTimer}
              spentTime={spentTime}
            />
          </div>
        )}

        {currentPage && (
        <EbookComponent
            wrapperStyles={mobileLayout ? { top: 'calc(50% - 6vmin)' } : { top: '53%' }}
            // smallWidth={92}
            largeWidth={105}
            page={currentPage}
            assetsFolder={assetsFolder}
          />
        )}

        <ActivityButtons
          buttons={[
            {
              // Leaving the e-book must cancel the activity through the shared
              // GO_BACK handler. It must never stop the reading timer or submit
              // benchmark results; only the timer Stop button does that.
              type: GO_BACK
            },
            {
              type: NEXT,
              dontShow: shouldHideNextButton({
                options,
                gameData: timerModeData,
                timerStarted,
                isLastPage,
                isReady: !!currentPage && Array.isArray(pages)
              }),
              onClick: this.showNextPage
            },
            {
              type: PRINT,
              dontShow: !pdf,
              onClick: this.openPdf
            },
            HELP,
            {
              type: SPEAK,
              dontShow: !pageAudio,
              onClick: this.playPageAudio
            }
          ]}
        />
      </Layout>
    );
  }
}

ReadingDeluxe.propTypes = {
  showStats: PropTypes.func.isRequired
};

// Keep the Reading content locale independent from its presentation locale.
const mapStateToProps = ({ flinkPlay = {}, status = {} }) => ({
  presentationLocale: flinkPlay.solutionLocale || status.lang || null,
});

export default connect(mapStateToProps, { showStats })(ReadingDeluxe);
